const config = {
  baseURL: 'https://bvmwebsolutions.com/patreon-pass/backend/api',
};

export default config;
